import { ORDER_METHODS } from '../../../../../services/exports/Constants';
import { ValidationErrors } from '../../../../../modals/order-method/types';

export default {
  title: 'Wybierz lokalizację',
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Zamawianie do stolika',
    [ORDER_METHODS.PICKUP]: 'Odbiór',
    [ORDER_METHODS.DELIVERY]: 'Dostawa',
  },
  text_inputs: {
    address: {
      placeholder: 'Wyszukaj adres',
    },
    street_name: {
      placeholder: 'Ulica',
    },
    street_number: {
      placeholder: 'Numer domu',
    },
    city: {
      placeholder: 'Miasto',
    },
    zip: {
      placeholder: 'Kod pocztowy',
    },
  },
  time_options: {
    asap: {
      title: 'Standardowe',
      description: 'Gotowe za {{time}} min',
    },
    scheduled: {
      title: 'Zaplanuj na później',
    },
  },
  time_drop_down: {
    today: 'Dzisiaj',
  },

  pickup: {
    address: 'Adres odbioru',
    when: 'Kiedy?',
  },

  delivery: {
    where: 'Dokąd?',
    when: 'Kiedy?',
    address: 'Twój adres',
    delivery_area: 'Nasz zasięg dostawy',
  },

  buttons: {
    view_menu: 'Zobacz menu',
    see_hours: 'Zobacz godziny',
    next: 'Dalej',
    change: 'Zmień',
    save: 'Zapisz',
  },

  labels: {
    when: 'Kiedy?',
    pickup: 'Odbiór online',
    delivery: 'Dostawa',
    pickup_time: 'czas odbioru',
    delivery_time: 'czas dostawy',
    discount: 'Tylko tutaj {{value}} zniżki online',
    pre_orders_enabled: 'Na razie możesz złożyć zaplanowane zamówienie na później',
    change_location: '← Wróć do menu, jeśli wolisz inną lokalizację',
    return: 'Powrót',
  },

  items_dropped: {
    count_one: '{{count}} pozycja usunięta',
    count_few: 'Usunięto {{count}} produkty',
    count_many: 'Usunięto {{count}} produktów',
    count_other: '{{count}} pozycji usuniętych',
    pickup_reason: '— niedostępne do odbioru.',
    delivery_reason: '— niedostępne dla dostawy.',
  },

  error_messages: {
    [ValidationErrors.address_not_found]:
      'Przepraszamy, nie mogliśmy znaleźć tego adresu. Spróbuj ponownie, wpisując najpierw ulicę w polu wyszukiwania adresu.',
    [ValidationErrors.address_not_serviceable]:
      'Twój adres jest poza naszą strefą dostawy. Czy chcesz zmienić adres lub przełączyć się na odbiór własny? 😊',
    [ValidationErrors.no_drivers_available]:
      'Przepraszamy, w tej chwili nie możemy dostarczyć zamówienia. Czy chcesz zamówić z odbiorem własnym? 😊',
    pickup_unavailable: 'Przepraszamy, obecnie nie oferujemy odbioru własnego.',
    delivery_unavailable: 'Przepraszamy, obecnie nie oferujemy dostawy.',
    delivery_paused: 'Przepraszamy, obecnie nie oferujemy dostawy.',
    outside_pickup_times: 'W tej chwili odbiór jest niedostępny. Nasze godziny odbioru:',
    outside_delivery_times: 'W tej chwili dostawa jest niedostępna. Nasze godziny dostawy:',
    orders_paused_inactivity:
      'Ze względu na duże zainteresowanie nie możemy teraz przyjmować więcej zamówień online. Zamów w lokalu lub spróbuj ponownie za 30 minut.',
    orders_paused_manual_end_of_day: 'Przepraszamy, jesteśmy zamknięci do końca dnia.',
    orders_paused_manual_until_time:
      'Ze względu na duże zainteresowanie nie możemy teraz przyjmować więcej zamówień online. Zamów w lokalu lub spróbuj ponownie od {{pausedUntil}}',
    company_closed: 'Niestety, w tej chwili jesteśmy zamknięci.',
    pickup_closed:
      'Przyjmujemy zamówienia na odbiór do {{time}}, ponieważ czas przygotowania wynosi {{preparationTime}} minut.',
    delivery_closed:
      'Przyjmujemy zamówienia z dostawą do {{time}}, ponieważ czas dostawy wynosi {{preparationTime}} minut.',
    live_orders_off: 'Przepraszamy, nie możemy teraz przyjmować więcej zamówień online. Dziękujemy za wyrozumiałość.',
    orders_unavailable: '{{type}} jest niedostępny w tej chwili. Następny możliwy {{typeTime}} to {{day}} {{time}}.',
  },

  no_couriers: {
    with_code:
      'Przepraszamy, w tej chwili nie mamy dostępnych kierowców. Spróbuj ponownie później lub zamów z odbiorem i użyj kodu promocyjnego <PromoCode>{{code}}</PromoCode> przy kasie.',
    without_code:
      'Przepraszamy, w tej chwili nie mamy dostępnych kierowców. Spróbuj ponownie później lub zamów z odbiorem własnym.',
    copied: 'Kod promocyjny skopiowany',
  },
};
